import React, { useEffect, useState } from "react";
import MenuCreate from "./MenuCreate";
import { Button, Pagination } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileCirclePlus,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { DeleteMenu, getAllMenulist } from "services/apiService";
import DynamicButton from "../../common/DynamicButton";
import CommonTable from "common/CommonTable";
import loadingImage from "../../assect/loadingSvg/loading.svg";
import toast from "react-hot-toast";

const MenuList = () => {
  const [data, setData] = useState<any[]>([]);
  const [isOpenCouponEdit, setIsOpenCouponEdit] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [filteredCoupons, setFilteredCoupons] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const itemsPerPage = 10;

  const headers = ["S.no", "Name", "Status", "Action"];

  useEffect(() => {
    fetchMenuList();
  }, []);

  const fetchMenuList = async () => {
    setLoader(true);
    try {
      const response = await getAllMenulist();
      if (response.status_code === 200) {
        setData(response.data || []);
        setFilteredCoupons(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching menu list:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);

    const filtered = data.filter((menu) =>
      menu.menu_name?.toLowerCase().includes(value)
    );

    setFilteredCoupons(filtered);
    setCurrentPage(1);
  };

  const handlePageChange = (_: React.ChangeEvent<unknown>, page: number) => {
    setCurrentPage(page);
  };

  const paginatedData = filteredCoupons.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const startIndex = (currentPage - 1) * itemsPerPage;

  const handleDelete = async (id: number) => {
    try {
      const payload = {
        id: id,
      };
      const response = await DeleteMenu(payload);
      if (response.status_code === 200) {
        toast.success("Menus deleted Successfully");
        fetchMenuList();
      }
    } catch (error) {
      toast.error("Failed to delete the Menu");
    }
  };

  const renderRow = (coupon: any, index: number) => (
    <tr key={index}>
      <td>{startIndex + index + 1}</td>
      <td className="align-content-center" title={coupon?.menu_name}>
        {coupon.menu_name}
      </td>

      <td className="align-content-center">
        <span
          style={{
            color: coupon.is_active ? "green" : "red",
            backgroundColor: coupon.is_active ? "#e0f7e9" : "#f8d7da",
            padding: "5px 10px",
            borderRadius: "5px",
            display: "inline-block",
          }}
        >
          {coupon?.is_active ? "Active" : "Inactive"}
        </span>
      </td>
      <td className="align-content-center">
        <DynamicButton
          icon={faTrashCan}
          iconStyle={{ color: "#f54242" }}
          style={{
            padding: "0",
            border: "none",
            background: "none",
            cursor: "pointer",
            margin: "2px",
          }}
          onClick={() => handleDelete(coupon.menu_id)}
        />
      </td>
    </tr>
  );

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className="col-lg-6">
          <Button
            variant="contained"
            color="primary"
            sx={{ borderRadius: "0px" }}
            onClick={() => setIsOpenCouponEdit(true)}
          >
            <FontAwesomeIcon
              icon={faFileCirclePlus}
              style={{ marginRight: "10px" }}
            />
            Create Menus
          </Button>
        </div>
        <div className="col-lg-5 d-flex mb-3">
          <input
            type="text"
            placeholder="Search menus..."
            className="form-control"
            style={{ boxShadow: "none" }}
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
      </div>
      <div className="product-table-content">
        {loader ? (
          <div className="loadingsvg-Image text-center">
            <img src={loadingImage} width={150} height={150} alt="Loading..." />
          </div>
        ) : (
          <CommonTable
            data={paginatedData}
            isLoading={loader}
            headers={headers}
            renderRow={renderRow}
          />
        )}
      </div>
      <div className="pagination-container">
        <div className="data-info" style={{ color: "grey" }}>
          <span>
            Showing {startIndex + 1}-
            {Math.min(startIndex + itemsPerPage, filteredCoupons.length)} of{" "}
            {filteredCoupons.length}
          </span>
        </div>
        <Pagination
          count={Math.ceil(filteredCoupons.length / itemsPerPage)}
          page={currentPage}
          onChange={handlePageChange}
          color="primary"
          variant="outlined"
          shape="rounded"
        />
      </div>
      <MenuCreate
        isOpen={isOpenCouponEdit}
        handleClose={() => setIsOpenCouponEdit(false)}
        isAutoComplete={fetchMenuList}
      />
    </>
  );
};

export default MenuList;
